import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import __DEPRECATED_defineResources from 'dpl/shared/fetching/deprecated/defineResources';
import withScrollSpy from 'dpl/decorators/withScrollSpy';
import { groupBy } from 'dpl/shared/utils';
import ExplorePage, {
  HEADER_HEIGHT
} from 'dpl/breed_explorer/components/ExplorePage';
import { PHOTO_ALBUM_TYPE, IMAGE_ID } from 'dpl/constants/query_params';
import { PHOTO_ALBUM_TYPES } from 'dpl/shared/constants/breeder_app';
import { pushParams } from 'dpl/actions/query_params';
import { exploreBreedsResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';

function ExplorePageContainer(props) {
  return <ExplorePage {...props} />;
}

export default compose(
  connect((state, props) => {
    const breedCategories = state.server.breedCategories.data;
    let { breedCategorySlug } = props.match.params;

    // invalid category
    if (!breedCategories.some(bc => bc.slug === breedCategorySlug)) {
      breedCategorySlug = '';
    }

    return {
      breedCategorySlug,
      breedCategories
    };
  }),
  __DEPRECATED_defineResources((state, { breedCategorySlug }) => ({
    breedPhotosData: {
      url: `/api/breed_categories/${breedCategorySlug}/photographs.json`,
      auto: Boolean(breedCategorySlug),
      defaultValue: { data: [] }
    },
    breedsData: exploreBreedsResourceDefinition()
  })),
  connect(
    (state, props) => {
      const { breedCategorySlug, breedPhotosData, breedsData } = props;

      let { breedSlug } = props.match.params;

      const photosByBreed = groupBy(breedPhotosData.value.data, 'breed_slug');

      const breedsForCategory = breedsData.value.data.filter(
        b =>
          b.breed_category_slugs.includes(breedCategorySlug) &&
          b.slug in photosByBreed
      );

      // invalid breed
      if (!breedsForCategory.some(b => b.slug === breedSlug)) {
        breedSlug = '';
      }

      return {
        breedSlug,
        breedsForCategory,
        photosByBreed,
        photos: props.breedPhotosData.value.data,
        displayedImageId: state.queryParams[IMAGE_ID]
          ? Number(state.queryParams[IMAGE_ID])
          : null
      };
    },
    {
      onImageClick: id =>
        pushParams(
          {
            [IMAGE_ID]: id,
            [PHOTO_ALBUM_TYPE]: PHOTO_ALBUM_TYPES.BREEDER
          },
          { hash: true }
        )
    }
  ),
  withScrollSpy(HEADER_HEIGHT)
)(ExplorePageContainer);
